import React from "react";
import Referees from "@/components/Pages/Dashboard/Referees";

const RefereesPage: React.FC = () => {
  return <Referees />;
};

export default RefereesPage;
